import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Button, Grid, TextField, Typography} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {useHasScope} from "../../../../../../config/globalConfig";
import {THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL} from "../../../../component/utils/AuthConstants";

const DriverDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(true);
    const navigate = useNavigate();
    const driverDetailsObject = props.driverDetailsObject;
    const additionalDriverDetailsObject = props.additionalDriverDetailsObject;
    const id = props.id;
    const hasScope = useHasScope;
    return (
        <Accordion defaultExpanded onChange={(_e, expanded) => {
            setIsExpanded(expanded);
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("customerRADetails.driversDetails")}
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={12}>
                        <Typography>{t("driversDetails.firstDriver")}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="firstName"
                            value={driverDetailsObject?.firstName}
                            label={t("customerDetails.firstName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="lastName"
                            value={driverDetailsObject?.lastName}
                            label={t("customerDetails.lastName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>

                        <TextField
                            label={t("customerDetails.birthDate")}
                            value={driverDetailsObject?.birthDate ? dayjs(driverDetailsObject.birthDate).format("L") : ""}
                            fullWidth
                            disabled={true}
                            id="birthDate"
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />

                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="birthPlace"
                            value={driverDetailsObject?.birthPlace?.code}
                            label={t("customerDetails.birthPlace")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="country"
                            value={driverDetailsObject?.birthNation?.description}
                            label={t("customerDetails.country")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="taxCode"
                            value={driverDetailsObject?.fiscalCode}
                            label={t("customerDetails.taxCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="addressOfResidence"
                            value={driverDetailsObject?.address}
                            label={t("customerDetails.addressOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="cityOfResidence"
                            value={driverDetailsObject?.cityResidence?.description}
                            label={t("customerDetails.cityOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="postalCode"
                            value={driverDetailsObject?.postCode}
                            label={t("customerDetails.postalCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="province"
                            value={driverDetailsObject?.provinceResidence?.description}
                            label={t("customerDetails.province")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="countryOfResidence"
                            value={driverDetailsObject?.countryResidence?.description}
                            label={t("customerDetails.countryOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="license"
                            value={driverDetailsObject?.drivingLicenseNumber}
                            label={t("driversDetails.license")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="prefix"
                            value={driverDetailsObject?.prefix?.description}
                            label={t("driversDetails.prefix")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="phoneNumber"
                            value={driverDetailsObject?.mobile}
                            label={t("driversDetails.phoneNumber")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="email"
                            value={driverDetailsObject?.email}
                            label={t("driversDetails.email")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                {hasScope(THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL) &&
                                    <Button color={"accent"} onClick={() => {
                                        navigate(`/finessecurity/watchlist/addCustomer`, {
                                            state: {
                                                customer: driverDetailsObject
                                            }
                                        });
                                    }}>
                                        {t("tabs.addToBlacklist")}
                                    </Button>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br></br>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={12}>
                        <Typography>{t("driversDetails.additionalDriver")}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="firstName"
                            value={additionalDriverDetailsObject?.firstName}
                            label={t("customerDetails.firstName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="lastName"
                            value={additionalDriverDetailsObject?.lastName}
                            label={t("customerDetails.lastName")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label={t("customerDetails.birthDate")}
                            value={additionalDriverDetailsObject?.birthDate ? dayjs(additionalDriverDetailsObject.birthDate).format("L") : ""}
                            fullWidth
                            disabled={true}
                            id="birthDate"
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="birthPlace"
                            value={additionalDriverDetailsObject?.birthPlace?.code}
                            label={t("customerDetails.birthPlace")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="country"
                            value={additionalDriverDetailsObject?.birthNation?.description}
                            label={t("customerDetails.country")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="taxCode"
                            value={additionalDriverDetailsObject?.fiscalCode}
                            label={t("customerDetails.taxCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="addressOfResidence"
                            value={additionalDriverDetailsObject?.address}
                            label={t("customerDetails.addressOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="cityOfResidence"
                            value={additionalDriverDetailsObject?.cityResidence?.description}
                            label={t("customerDetails.cityOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="postalCode"
                            value={additionalDriverDetailsObject?.postCode}
                            label={t("customerDetails.postalCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="province"
                            value={additionalDriverDetailsObject?.provinceResidence?.description}
                            label={t("customerDetails.province")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="countryOfResidence"
                            value={additionalDriverDetailsObject?.countryResidence?.description}
                            label={t("customerDetails.countryOfResidence")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="license"
                            value={additionalDriverDetailsObject?.drivingLicenseNumber}
                            label={t("driversDetails.license")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="prefix"
                            value={additionalDriverDetailsObject?.prefix?.description}
                            label={t("driversDetails.prefix")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="phoneNumber"
                            value={additionalDriverDetailsObject?.mobile}
                            label={t("driversDetails.phoneNumber")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            id="email"
                            value={additionalDriverDetailsObject?.email}
                            label={t("driversDetails.email")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                {hasScope(THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL) &&
                                    <Button color={"accent"} onClick={() => {
                                        navigate(`/finessecurity/watchlist/addCustomer`, {
                                            state: {
                                                customer: additionalDriverDetailsObject
                                            }
                                        });
                                    }}>
                                        {t("tabs.addToBlacklist")}
                                    </Button>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default DriverDetails;